// extracted by mini-css-extract-plugin
module.exports = {"off-grid-Q":"Q_off-grid-Q__wKtgK"};